import { useSelector, TypedUseSelectorHook } from 'react-redux';
import { RootState } from '../store/config';

const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export default useTypedSelector;
